module.exports = __webpack_public_path__ + "static/media/icons-settings-gear.3c0d3afe.svg";